export default __webpack_public_path__ + "static/media/GabioDrainDesignNegativo.ef45c158.png";